export const relationshipOptions = [
  { label: 'Me', value: 'me' },
  { label: 'My spouse', value: 'spouse' },
  { label: 'My child', value: 'child' },
  { label: 'My mom', value: 'mom' },
  { label: 'My dad', value: 'dad' },
  { label: 'My grandma', value: 'grandma' },
  { label: 'My grandpa', value: 'grandpa' },
  { label: 'My friend', value: 'friend' },
  { label: 'Other', value: 'other' },
];

export default relationshipOptions;
